var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M15 10a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0-2.5c4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5-7.5-3.364-7.5-7.5 3.364-7.5 7.5-7.5M23.75 5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5M8.748 0C3.924 0 0 3.928 0 8.752v12.5C0 26.077 3.928 30 8.752 30h12.5C26.076 30 30 26.073 30 21.247v-12.5C30 3.925 26.073 0 21.248 0z",
    opacity: 0.704
  })));
};
export default SvgInstagram;